import type { ActionHandler } from '../types';
import { invokeSemanticPort, readString } from './helpers';

export const declineOfferHandler: ActionHandler = {
  type: 'decline_offer',
  execute(ctx) {
    const config = ctx.config;
    const offerId = readString(config, 'offerId', 'offer_id');
    const port = ctx.semanticPorts?.declineOffer;
    return invokeSemanticPort(
      ctx,
      'decline_offer',
      port
        ? (context) =>
            port(
              { offerId, stepId: readString(config, 'stepId', 'step_id') ?? ctx.stepId },
              context
            )
        : ctx.onOfferDecline
          ? async () => {
              // Decline is step-owned; an explicit offerId is optional.
              const outcome = await ctx.onOfferDecline!(offerId ?? '', {
                resultOwner: 'dispatcher',
              });
              if (outcome === false) {
                throw new Error('Host rejected the decline_offer operation');
              }
            }
          : undefined
    );
  },
};
